import { customAxios, customPatchAxios } from "./customAxios";

/**
 * 설비현황기준관리(기본현황) 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentStatusBasicItemsByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentStatusBasicItems', {params : query});
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비현황기준관리(기본현황) 상세
 * @param {*} id 
 * @returns 
 */
export const getEquipmentStatusBasicItemsById = async(id)=>{
  const res = await customAxios.get('/api/equipmentStatusBasicItems/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비현황기준관리(기본현황) 등록
 * @param {*} body 
 */ 
export const postEquipmentStatusBasicItems = async(body)=>{
  //console.log(body);
  await customAxios.post('/api/equipmentStatusBasicItems', body);
}

/**
 * 설비현황기준관리(기본현황) 수정
 * @param {*} body 
 */ 
export const patchEquipmentStatusBasicItems = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/equipmentStatusBasicItems/'+body.id, body);
}

/**
 * 설비현황기준관리(기본현황) 삭제
 * @param {*} param 
 */
export const deleteEquipmentStatusBasicItems = async(param)=>{
  //console.log(param);
  await customAxios.delete('/api/equipmentStatusBasicItems/'+param);
}


/**
 * 설비현황기준관리(성능현황) 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentStatusItemsByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentStatusItems', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비현황기준관리(성능현황) 상세
 * @param {*} id 
 * @returns 
 */
export const getEquipmentStatusItemsById = async(id)=>{
  const res = await customAxios.get('/api/equipmentStatusItems/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비현황기준관리(성능현황) 등록
 * @param {*} body 
 */ 
export const postEquipmentStatusItems = async(body)=>{
  //console.log(body);
  await customAxios.post('/api/equipmentStatusItems', body);
}

/**
 * 설비현황기준관리(성능현황) 수정
 * @param {*} body 
 */ 
export const patchEquipmentStatusItems = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/equipmentStatusItems/'+body.id, body);
}

/**
 * 설비현황기준관리(성능현황) 삭제
 * @param {*} param 
 */
export const deleteEquipmentStatusItems = async(param)=>{
  //console.log(param);
  await customAxios.delete('/api/equipmentStatusItems/'+param);
}
